const t = {
  name: "Bag",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7949 0C9.58264 0 7.79492 1.78772 7.79492 4V6H3.91211L1.66211 24H21.9277L19.6777 6H15.7949V4C15.7949 1.78772 14.0072 0 11.7949 0ZM15.6621 8L13.9121 22H3.92767L5.67767 8H15.6621ZM13.7949 6H9.79492V4C9.79492 2.89228 10.6872 2 11.7949 2C12.9026 2 13.7949 2.89228 13.7949 4V6ZM15.9277 22L17.6777 8H17.9121L19.6621 22H15.9277Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Bag
};
